export default __webpack_public_path__ + "static/media/fc_slide2.100b6426.png";